<template>
  <div class="home-menu">
    <van-grid :column-num="3" :border="false">
      <van-grid-item>
        <img
          fetchpriority="high"
          width="50"
          height="50"
          decoding="async"
          data-nimg="1"
          class="object-cover w-full h-[50px] max-w-[50px]"
          src="../../../assets/feature_01.svg"
          style="color: transparent"
        />
        <p>{{ $t("home.savings") }}</p>
      </van-grid-item>
      <van-grid-item>
        <img
          fetchpriority="high"
          width="50"
          height="50"
          decoding="async"
          data-nimg="1"
          class="object-cover w-full h-[50px] max-w-[50px]"
          src="../../../assets/feature_02.svg"
          style="color: transparent"
        />
        <p>{{ $t("home.rate") }}</p>
      </van-grid-item>
      <van-grid-item>
        <img
          fetchpriority="high"
          width="50"
          height="50"
          decoding="async"
          data-nimg="1"
          class="object-cover w-full h-[50px] max-w-[50px]"
          src="../../../assets/feature_03.svg"
          style="color: transparent"
        />
        <p>{{ $t("home.disbursement") }}</p>
      </van-grid-item>
    </van-grid>
  </div>
</template>
      
<script>
export default {
  name: "HomeMenuView",
};
</script>
<style scoped>
.home-menu{
  line-height: 1.6;
}
</style>
    